import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, GuardResult, MaybeAsync, Router, RouterStateSnapshot } from '@angular/router';
import { catchError, firstValueFrom, map, of, switchMap } from 'rxjs';
import { AuthService } from '../services/auth.service';


@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  private auth = inject(AuthService);
  private router = inject(Router);

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): MaybeAsync<GuardResult> {
    return this.auth.validateSession().pipe(
      switchMap(async response => {
        if (response === 'valid') {
          const res = await firstValueFrom(this.auth.getuserDetails())
          this.auth.intializeSessionAfterLogin(res);
          return true;
        }
        if (response === 'unauthorized') {
          this.router.navigate(['/not-authorized']);
          return false;
        }

        const queryParams: any = {};
        if (response.toLowerCase().includes('login')) {
          queryParams.ReturnUrl = state.url;
        }
        this.router.navigate([response], { queryParams: queryParams });
        return false;
      }),
      catchError(() => {
        this.router.navigate(['/login']);
        return of(false);
      })
    );
  }

}